import React from 'react';
import ToolbarButtonStyled from './ToolbarButton.styled';
import Icon from '@/components/icon/Icon';
import { IconsDictionary, IIcon } from '@/components/icon/Icon.types';
import Tooltip from '@/components/tooltip/Tooltip';
import { toSnakeCase } from '@/utils/toSnakeCase';

export interface ToolbarButtonProps {
  className?: string;
  id?: string;
  action: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  icon?: IIcon;
  srText?: string;
  isActive?: boolean;
  color?: string;
  children?: React.ReactNode;
  hasChevron?: boolean;
  tooltipText?: string;
  badge?: React.JSX.Element;
}

const ToolbarButton = ({
  action,
  icon,
  srText,
  isActive = false,
  color,
  children,
  hasChevron = false,
  tooltipText = '',
  badge,
  ...rest
}: ToolbarButtonProps) => {
  return (
    <ToolbarButtonStyled
      {...rest}
      aria-describedby={toSnakeCase(tooltipText)}
      data-id="toolbar-btn"
      type="button"
      onClick={e => action(e)}
      isActive={isActive}
    >
      {children}
      {icon && <Icon icon={icon} color={color} />}
      {hasChevron && (
        <Icon
          className="toolbar-btn__chevron"
          icon={IconsDictionary.Chevron}
          width={16}
          height={16}
          color="#fff"
        />
      )}
      {badge ? badge : null}
      {srText && <span className="sr-only">{srText}</span>}
      {tooltipText && (
        <Tooltip className="toolbar-btn__tooltip" text={tooltipText} />
      )}
    </ToolbarButtonStyled>
  );
};

export default ToolbarButton;
